// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";

// Import your page and layout components
import Sidebar from "./components/sidebar";
import Header from "./components/header";
import LoginPage from './components/loginpage';
import Dashboard from "./pages/Dashboard";
import Requests from "./pages/request";
import Users from "./pages/userpage";
import Events from "./pages/event";
import Settings from "./pages/settings";

/**
 * The DashboardLayout component serves as a wrapper for all authenticated pages.
 * It includes the Sidebar and Header, and an <Outlet /> component,
 * which renders the specific page content (e.g., Dashboard, Settings).
 */
const DashboardLayout = () => {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Header />
        <main className="flex-1 p-8 overflow-y-auto">
          <Outlet /> {/* Child routes will be rendered here */}
        </main>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Route for the standalone login page */}
        {/* <Route path="/login" element={<LoginPage />} /> */}
        
        {/* Catch-all route at the root, redirects to login */}
        <Route path="/" element={<LoginPage />} />

        {/* Nested routes for the authenticated dashboard area */}
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/requests" element={<Requests />} />
          <Route path="/users" element={<Users />} />
          <Route path="/events" element={<Events />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
